import type { SiteName } from '@/scopes/common/domain/types';

enum MultilanguagePrefix {
  FR = 'fr',
  NL = 'nl',
}

export function getMultilanguagePrefixBySiteName(siteName: SiteName): MultilanguagePrefix | undefined {
  switch (siteName) {
    case 'sunwebbenl':
      return MultilanguagePrefix.NL;
    case 'sunwebbefr':
      return MultilanguagePrefix.FR;
    default:
      return undefined;
  }
}
